export const selector = 'dbACustomError';

/* @ngInject */
export default function CustomErrorDirective($parse) {
    return {
        require: [
            '?ngModel',
            '?form'
        ],
        restrict: 'A',

        link(scope, element, attrs, [ngModel, form]) {
            const getError = $parse(attrs[selector]);

            scope.$watch(() => getError(scope), (error) => {
                setValidity(ngModel, !!error);
                setValidity(form, !!error);
            });

            function setValidity(ctrl, error) {
                if (ctrl) {
                    ctrl.$setValidity('error', !error);
                }
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/application/directive/custom-error/custom-error.directive.js